import { AxiosResponse } from 'axios';

import { useQueryClient } from '@tanstack/react-query';

import type { TypeCodeState, TypeContract } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useGetWorkShiftType */
export type TypeGetWorkShiftTypeParams = {
  /** 클러스터 */
  cluster: string;
  /** 센터 */
  center: string;
  /** 계약구분 */
  contractType?: TypeContract;
  /** 업무 파트 */
  workPart?: string;
  /** 팀명 */
  teamName?: string;
};

/** @category useGetWorkShiftType */
export type TypeGetWorkShiftTypeResponse = {
  code: string;
  message: string;
  data: TypeWorkShiftData[];
};

/** @category useGetWorkShiftType */
export type TypeWorkShiftData = {
  id: number;
  cluster: TypeCodeState;
  center: TypeCodeState;
  workPart: TypeCodeState;
  teamName: string;
  active: boolean;
  workShift: {
    startTime: string;
    endTime: string;
    isStartTimeBeforeEndTime: boolean;
    formattedText: string;
  };
};

/**
 * @description 출근 정보 등록 페이지에서 근무 shift를 조회하는 커스텀 훅
 */
export const useGetWorkShiftType = () => {
  const queryClient = useQueryClient();

  const requestWorkShiftType = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeGetWorkShiftTypeParams;
    onSuccess?: (res: TypeGetWorkShiftTypeResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    const endpoint = '/center-work-shifts';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeGetWorkShiftTypeResponse>>({
      queryKey: ['center-work-shifts', params],
      queryFn: () => axiosInstance.get(endpoint, { params }),
      gcTime: 0,
    });

    return requestHelper(() => query, onSuccess, onError);
  };

  return requestWorkShiftType;
};
